import $ from 'jquery';
import abgrcs_config from './abgrcs_config.js';

var abgrcs_nav_header2 = new Array();

for (let index2 = 0; index2 < Object.keys(abgrcs_config.service_array).length; index2++) {
  abgrcs_nav_header2.push(
    <>
      <div class="col-lg-4">
        <div class="image-wrap-2">
          <div class="image-info">
            <h2 class="mb-3">{abgrcs_config.service_array[index2].single_name}</h2>
            <a href={"/single/" + index2} class="btn btn-outline-white py-2 px-4">More Photos</a>
          </div>
          <img src={abgrcs_config.service_array[index2].single_img} alt="Image" class="img-fluid" />
        </div>
      </div>
    </>
  );
}

var abgrcs_nav_header2 = (
  abgrcs_nav_header2
);

function Home() {
  return (
    <div class="row">
      {abgrcs_nav_header2}
    </div>
  );
}

export default Home;


/*

$.post(abgrcs_config.site_url  + "/get_static.php?function=get_articles&user_id=" + abgrcs_config.user_inf.user_id, function(abgrcs_data){
    var result = JSON.parse(abgrcs_data);
    
    $("#computers_table").find('tbody')("");
    
    if( result.length > 0 )
    {
      for( var i = 0; i < result.length ;i++ )
      {
        var the_elements = result[i];
        
        $("#computers_table").find('tbody').append(' \
          <tr> \
            <td>' + the_elements.article_id + '</td> \
            <td><a href="/articles/' + the_elements.article_id + '">' + the_elements.article_title + '</a></td> \
            <td> \
              <a href="#" onclick="articles_edit_show(' + the_elements.article_id + '); return false;"><i class="fa fa-edit"></i></a> \
              <a onclick="if(!confirm(\'Confirmer cette etape\')) return false; else { articles_delete(' + the_elements.article_id + '); return false; }" href="#"><i  class="fa fa-trash"></i></a> \
            </td> \
          </tr> \
        ');
      }
      
      $("#img_to_show").hide();  
      $("#bnt_to_show").removeAttr('disabled'); 
    }
    else
    {
      $("#computers_table").find('tbody').append(' \
        <tr> \
          <td colspan="7" style="text-align:center;"><br />No Article found.<br /><br /></td> \
        </tr> \
      ');
      
      $("#img_to_show").hide();  
      $("#bnt_to_show").removeAttr('disabled'); 
    }
  });
function articles_add_show(article_id)
{
	$("#article_title").val("");
	
	$("#model_article_bar_title")("Add article");
	$("#model_article_bnt_add_edit")("Add");
	$("#model_article_bnt_add_edit").attr("onclick", "articles_add();");
	
	window.$('#model_articles_add').modal('show');
}
*/